module.exports = __webpack_public_path__ + "img/en.39b4de2d.png";